import { Injectable, resource, signal } from '@angular/core';
import { RestDatasource } from '@core/api/rest.datasource';
import { PensionsudbyderHistorik } from '@features/pensionsudbydere/pu-historik/pu-historik.model';

@Injectable({
  providedIn: 'root',
})
export class PuHistorikDatasource extends RestDatasource<PensionsudbyderHistorik> {
  override endpoint = '/api/admin/pensionsudbyderhistorik';

  pensionsudbyderId = signal<number | undefined>(undefined);
  data = resource({
    params: () => this.pensionsudbyderId(),
    loader: async ({ params, abortSignal }) => {
      return await this.getList(
        {
          filter: JSON.stringify({
            pensionsudbyderId: params,
          }),
          sortBy: 'tidspunkt',
          descending: true,
        },
        abortSignal
      );
    },
  });
}
